export default "__VITE_ASSET__m_kfjplj__"